import type { CSSProperties } from "react";

import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Textfield, TextfieldLabel, Button, ButtonLabel, IconButton } from "@similarweb/ui-components";

import type { EnrichmentType } from "app/pages/sales-intelligence/modules/enrichment/types/types";

export const StyledLoadList = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-top: 10%;

    &.withBoxShadow {
        box-shadow: 0px 3px 6px rgba(14, 30, 62, 0.08);
    }

    &.enrichment {
        width: 632px;
        height: 270px;
        margin: 0;
        padding-top: 10px;
        display: flex;
        justify-content: center;
    }
    &.contact-enrichment {
        width: 680px;
        height: auto;
        margin: 0;
        padding: 24px 16px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        box-sizing: border-box;
    }

    &.domains-limit {
        display: flex;
        height: auto;
        margin-top: 0;
    }

    background-color: ${colorsPalettes.carbon[0]};
    width: 788px;
    height: 364px;
`;

export const StyledLoadListHeader = styled.div<{ marginBottom?: string }>`
    margin-top: 32px;
    margin-bottom: ${(p) => p.marginBottom || "33px"};
    ${setFontVariant("h4", colorsPalettes.carbon[500])}
    line-height: 32px;
    text-align: center;
`;

export const StyledLoadListSubtitle = styled.p`
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
    text-align: center;
    line-height: 20px;
    margin-bottom: 48px;
    display: inline-flex;
`;

export const StyledPreviousStepButton = styled.button`
    padding: 0;
    margin: 0 0 0 3px;
    box-shadow: none;
    border: none;
    ${setFontVariant("body2", colorsPalettes.blue[400])};
    background: transparent;
    line-height: 20px;

    &:hover {
        text-decoration: underline;
    }
`;

export const StyledTextfield = styled(Textfield)`
    width: 352px;

    ${TextfieldLabel} {
        color: ${colorsPalettes.carbon[400]};
    }
`;

export const StyledLoadListActionsContainer = styled.div`
    display: inline-flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: auto;
    box-sizing: border-box;
    width: 100%;
    padding: 0 32px 32px 0;
`;

export const StyledButton = styled(Button)`
    margin-right: 8px;

    ${ButtonLabel} {
        font-weight: 700;
    }
`;

export const StyledInfoWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const StyledLoadListInfo = styled.div`
    width: 315px;
    margin-left: 20px;
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
    line-height: 20px;
`;
export const StyledLoadListUploadContainer = styled.div<{ type: EnrichmentType }>`
    margin-bottom: 10px;
    margin-top: ${({ type }) => (type === "company" ? "36px" : "16px")};
`;

export const StyledInputListWrapper = styled.div`
    display: table-cell;
    width: 298px;

    background-color: ${colorsPalettes.bluegrey[100]};
    border: 1px dashed ${colorsPalettes.blue[400]};
    border-radius: 5px;
    text-align: center;
    vertical-align: middle;

    &.isError {
        border: 1px dashed ${colorsPalettes.red[400]};
    }

    &.isFileLoading {
        pointer-events: none;
        border: 1px dashed ${colorsPalettes.carbon[200]};
    }
`;

export const StyledLabel = styled.label<{ type: EnrichmentType }>`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${({ type }) => (type === "company" ? "15px 0" : "62px 0px")};
    position: relative;
    height: 100%;
    width: 100%;

    & path {
        fill: ${colorsPalettes.blue[400]};
    }
`;

export const StyledInput = styled.input`
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
`;

export const StyledLoadListHint = styled.div`
    ${setFontVariant("queryBar1", colorsPalettes.carbon[300])};
    line-height: 12px;
    width: 130px;
    text-align: center;
`;

export const StyledLabelText = styled.b`
    display: block;
    padding: 5px;
    text-align: center;
    line-height: 20px;
    cursor: pointer;
    ${setFontVariant("button", colorsPalettes.blue[400])};

    &.isFileLoading {
        color: ${colorsPalettes.carbon[250]};
    }
`;

export const StyledUploadListPageHeader = styled.div`
    display: inline-flex;
    height: 48px;
    margin-top: 35px;
`;

export const StyledBackBtnWrapper = styled.div`
    left: 24px;
    position: absolute;
    top: 5%;
    transform: translateY(-50%);
`;

export const StyledErrorContainer = styled.div`
    ${setFontVariant("listItem3", colorsPalettes.red[400])};
`;

export const StyledClosePopup = styled(IconButton)`
    right: 15px;
    top: 15px;
    position: absolute;
`;

export const LOADER_OPTIONS = {
    svg: {
        stroke: colorsPalettes.carbon[250],
        strokeWidth: 2,
        r: 8,
        cx: "50%",
        cy: "50%",
    },
    style: {
        position: "initial" as CSSProperties["position"],
        width: 26,
        height: 26,
    },
};

export const CUSTOM_STYLES = {
    content: { padding: "20px 16px 16px 24px", width: "460px", height: "224px" },
};

export const TITLE_STYLES = { marginBottom: "32px" };
